<template>
  <v-app>
    <v-main>
      <transition name="slide" mode="out-in">
        <router-view v-if="loaded"></router-view>
      </transition>
      <!-- dialog ปุ่มกด เบอร์ -->
      <v-dialog v-model="dialogConfirmMember" persistent fullscreen>
        <v-card>
          <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
            xmlns:svgjs="http://svgjs.dev/svgjs" :width="widthScreen" :height="heigthScreen + 20"
            preserveAspectRatio="none" viewBox="0 0 1440 1400">
            <g mask='url("#SvgjsMask1022")' fill="none">
              <rect width="1440" height="1400" x="0" y="0" fill='url("#SvgjsLinearGradient1023")'></rect>
              <path d="M0 0L524.4 0L0 519.63z" fill="rgba(255, 255, 255, .2)"></path>
              <path d="M0 519.63L524.4 0L834.93 0L0 903.51z" fill="rgba(255, 255, 255, .1)"></path>
              <path d="M0 903.51L834.93 0L911.0699999999999 0L0 1162.46z" fill="rgba(255, 255, 255, .1)"></path>
              <path d="M0 1162.46L911.0699999999999 0L1026.9199999999998 0L0 1316.97z" fill="rgba(255, 255, 255, .025)">
              </path>
              <path d="M1440 1400L1288.49 1400L1440 969.5699999999999z" fill="rgba(0, 0, 0, .1)"></path>
              <path d="M1440 969.5699999999999L1288.49 1400L670.45 1400L1440 956.0799999999999z"
                fill="rgba(0, 0, 0, .095)"></path>
              <path d="M1440 956.0799999999999L670.45 1400L299.99000000000007 1400L1440 891.93z"
                fill="rgba(0, 0, 0, .07)"></path>
              <path d="M1440 891.93L299.99 1400L242.81 1400L1440 723.64z" fill="rgba(0, 0, 0, .025)"></path>
            </g>
            <defs>
              <mask id="SvgjsMask1022">
                <rect width="1440" height="1400" fill="#ffffff"></rect>
              </mask>
              <linearGradient x1="0.69%" y1="-0.71%" x2="99.31%" y2="100.71%" gradientUnits="userSpaceOnUse"
                id="SvgjsLinearGradient1023">
                <stop :stop-color="$bgColor" offset="0"></stop>
                <stop :stop-color="$bgColor2" offset="1"></stop>
              </linearGradient>
            </defs>
          </svg>
          <v-container :style="branchId
              ? 'top: 40px;position: absolute;'
              : 'top: 100px;position: absolute;'
            ">
            <v-alert v-if="branchId" icon="mdi-shield-lock-outline" dense dark :color="$bgColor2">
              {{ $t("message.IfYouAreAmemberOf") }}
              <strong style="text-decoration: underline;">{{                logo && logo.name                }}</strong>
              {{ $t("message.pleaseEnterNumberUsed") }}
            </v-alert>
            <v-card class="pa-4" v-show="loginTel" style="border-radius: 20px !important">
              <div style="text-align: center;">
                <div style="text-align: end;">
                  <!-- <v-btn rounded class="mb-2" small @click="loginTel = false"><v-icon class="mr-2">mdi-arrow-left-circle</v-icon>{{ $t("message.back") }}</v-btn> -->
                </div>
                <v-form v-model="validAdd" lazy-validation>
                  <v-avatar size="90" class="mb-5" style="border: solid 1px #ececec;">
                    <img v-if="logo" :src="logo.logo" />
                  </v-avatar>
                  <div class="mb-1">
                    <h3 class="mb-0">{{ logo && logo.name }}</h3>
                  </div>
                  <div class="mb-5" v-if="masBranchName" style="font-weight: 600 !important;">
                    {{ masBranchName }}
                  </div>
                  <div class="mb-5">
                    {{
                      this.shopId === "U97dd281445cde30a599a5f5515a4e937"
                        ? "Magic gift card"
                        : $t("message.login")
                    }}<v-icon class="iconify pb-1 ml-1" data-icon="mdi:login-variant"></v-icon>
                  </div>
                  <v-text-field :rules="[rules.counterTel]" v-model="tel" outlined prepend-inner-icon="mdi-cellphone"
                    :label="this.$t('message.fillTel')"></v-text-field>
                  <v-btn class="mt-2" style="width: 95%;color: white !important" @click="checkIsmember"
                    :disabled="!validAdd || !tel" :loading="loadingBtn" color="green">
                    {{ $t("message.login") }}
                  </v-btn>
                </v-form>
              </div>
            </v-card>
            <div style="text-align: center;margin-top: 20px">
              <v-chip class="mr-2" @click="changlangue('th')">
                <v-avatar left>
                  <v-img :src="thai"></v-img>
                </v-avatar>
                TH
              </v-chip>
              <v-chip class="mr-2" @click="changlangue('en')">
                <v-avatar left>
                  <v-img :src="eng"></v-img>
                </v-avatar>
                EN
              </v-chip>
            </div>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- dialog ปุ่มกด เบอร์ -->

      <!-- dialog ใส่ pin -->
      <v-dialog v-model="dialogPin" persistent fullscreen>
        <v-card>
          <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
          <div style="text-align: end;padding:10px">
            <v-btn rounded class="mb-2" small @click="
              (dialogPin = false), (loadingBtn = false), (pin_number = '')
              "><v-icon class="mr-2">mdi-arrow-left-circle</v-icon>{{ $t("message.back") }}</v-btn>
          </div>
          <v-list three-line subheader
            style="padding: 20px;display: flex;justify-content: center;padding-bottom: 15px;padding-top: 5px">
            <div style="text-align: center">
              <v-avatar left>
                <v-img :src="require('@/assets/padlock.png')"></v-img>
              </v-avatar>
              <v-subheader style="font-size:16px">{{
                $t("message.confirmPin")
                }}</v-subheader>
            </div>
          </v-list>
          <div style="display: flex;justify-content: center;">
            <div class="mr-4" :style="'width: 9px;border-radius: 111px;padding: 11px;background-color:' +
              count1() +
              'border: solid 2px grey;'
              "></div>
            <div class="mr-4" :style="'width: 9px;border-radius: 111px;padding: 11px;background-color:' +
              count2() +
              'border: solid 2px grey;'
              "></div>
            <div class="mr-4" :style="'width: 9px;border-radius: 111px;padding: 11px;background-color:' +
              count3() +
              'border: solid 2px grey;'
              "></div>
            <div class="mr-4" :style="'width: 9px;border-radius: 111px;padding: 11px;background-color:' +
              count4() +
              'border: solid 2px grey;'
              "></div>
            <div class="mr-4" :style="'width: 9px;border-radius: 111px;padding: 11px;background-color:' +
              count5() +
              'border: solid 2px grey;'
              "></div>
            <div :style="'width: 9px;border-radius: 111px;padding: 11px;background-color:' +
              count6() +
              'border: solid 2px grey;'
              "></div>
          </div>
          <div v-if="shopId !== 'U43e7e7332135fa3253d4a1385a8a89ce'"
            style="text-align: center;margin-top: 25px;text-decoration: underline" @click="createOtp">
            {{ $t("message.forgotPin") }}
          </div>
          <v-list three-line subheader style="margin-top: 25px;">
            <div style="display: flex;justify-content: space-between;" class="mb-6">
              <div cols="4" class="text-center" style="padding-left: 60px">
                <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPin('1')">
                  <span class="black--text text-h5">1</span>
                </v-avatar>
              </div>
              <div cols="4" class="text-center">
                <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPin('2')">
                  <span class="black--text text-h5">2</span>
                </v-avatar>
              </div>
              <div cols="4" class="text-center" style="padding-right: 60px">
                <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPin('3')">
                  <span class="black--text text-h5">3</span>
                </v-avatar>
              </div>
            </div>
            <div style="display: flex;justify-content: space-between;" class="mb-6">
              <div cols="4" class="text-center" style="padding-left: 60px">
                <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPin('4')">
                  <span class="black--text text-h5">4</span>
                </v-avatar>
              </div>
              <div cols="4" class="text-center">
                <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPin('5')">
                  <span class="black--text text-h5">5</span>
                </v-avatar>
              </div>
              <div cols="4" class="text-center" style="padding-right: 60px">
                <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPin('6')">
                  <span class="black--text text-h5">6</span>
                </v-avatar>
              </div>
            </div>
            <div style="display: flex;justify-content: space-between;" class="mb-6">
              <div cols="4" class="text-center" style="padding-left: 60px">
                <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPin('7')">
                  <span class="black--text text-h5">7</span>
                </v-avatar>
              </div>
              <div cols="4" class="text-center">
                <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPin('8')">
                  <span class="black--text text-h5">8</span>
                </v-avatar>
              </div>
              <div cols="4" class="text-center" style="padding-right: 60px">
                <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPin('9')">
                  <span class="black--text text-h5">9</span>
                </v-avatar>
              </div>
            </div>
            <div style="display: flex;justify-content: space-between;" class="mb-6">
              <div cols="4" class="text-center" style="padding-left: 60px">
                <v-avatar color="white" size="62">
                  <span class="black--text text-h5"></span>
                </v-avatar>
              </div>
              <div cols="4" class="text-center">
                <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPin('0')">
                  <span class="black--text text-h5">0</span>
                </v-avatar>
              </div>
              <div cols="4" class="text-center" style="padding-right: 60px">
                <v-avatar style="border:solid grey !important" color="white" size="62" @click="deletePin()">
                  <span class="black--text text-h5"><v-icon size="32">mdi-backspace</v-icon></span>
                </v-avatar>
              </div>
            </div>
            <!-- <div style="display: flex;justify-content: space-between;" class="mb-6">
            <div cols="4" class="text-center">
              <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPin('0')">
                <span class="black--text text-h5">0</span>
              </v-avatar>
            </div>
            <div cols="4" class="text-center">
              <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPin('0')">
                <span class="black--text text-h5">0</span>
              </v-avatar>
            </div>
            <div cols="4" class="text-center" style="padding-right: 60px">
              <v-avatar class="pb-1" color="white" size="62" @click="deletePin()">
                <span class="black--text text-h5"><v-icon size="32">mdi-backspace</v-icon></span>
              </v-avatar>
            </div>
          </div> -->
          </v-list>
        </v-card>
      </v-dialog>
      <!-- dialog ใส่ pin -->

      <!-- dialog otp -->
      <v-dialog transition="dialog-bottom-transition" max-width="600" v-model="dialogOTP" persistent>
        <v-card>
          <v-toolbar :color="$bgColor2" dark>
            <div>{{ $t("message.resetOtpPin") }}</div>
            <v-spacer></v-spacer><v-icon @click="(dialogOTP = false), (loadingbtn = false)">mdi-close</v-icon>
          </v-toolbar>
          <v-card-text class="text-h2 px-5" style="font-family: Kanit !important;">
            <p style="font-size: 15px;height: 33px;padding-left: 10px;" class="mb-0">
              {{ $t("message.waiting") }}
            </p>
            <div class="pa-1" style="display:flex;font-size: 15px">
              <v-icon>mdi-cellphone-key</v-icon>
              <p class="mb-0 mr-3">{{ $t("message.otpSentTo") }}</p>
              <p class="mb-0">{{ this.tel }}</p>
            </div>
            <v-text-field v-model="otpPassword" class="mt-5" :label="`${this.$t('message.enterOtp')}`"
              maxlength="4"></v-text-field>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn color="success" @click="otpCheck">{{
              $t("message.confirm")
              }}</v-btn>
            <!-- <v-btn
              color="error"
              @click="dialogOTP = false"
            >ปิด</v-btn> -->
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- dialog otp -->

      <!-- dialog reset pin -->
      <v-dialog v-model="dialogResetPin" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
          <div style="text-align: end;padding:10px">
            <!-- <v-btn rounded class="mb-2" small @click="dialogPin = false, loadingBtn = false"><v-icon class="mr-2">mdi-arrow-left-circle</v-icon>{{ $t("message.back") }}</v-btn> -->
          </div>
          <v-list three-line subheader
            style="padding: 20px;display: flex;justify-content: center;padding-bottom: 15px;padding-top: 5px">
            <div style="text-align: center">
              <v-avatar left size="85">
                <v-icon style="font-size: 50px;">mdi-lock-reset</v-icon>
              </v-avatar>
              <v-subheader style="font-size:16px">{{
                $t("message.resetPin")
                }}</v-subheader>
            </div>
            <!-- <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Content filtering</v-list-item-title>
              <v-list-item-subtitle>Set the content filtering level to restrict apps that can be downloaded</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Password</v-list-item-title>
              <v-list-item-subtitle>Require password for purchase or use password to restrict purchase</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item> -->
          </v-list>
          <div class=" mb-0 px-4" style="color: #8f8c8c;font-weight: bold;display:flex">
            <p class="mb-0" style="color:red">****</p>
            {{ $t("message.resetPinMessage") }}
          </div>
          <div>
            <v-col cols="12" sm="6">
              <v-text-field v-model="newPin" type="number" counter="6" outlined dense
                :label="`${this.$t('message.newPin')} `"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="newPinConfirm" type="number" counter="6" v-mask="'######'" outlined dense
                :label="`${this.$t('message.confirmNewPin')} `"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-btn @click="changeNewPin" color="orange" style="color: white !important" block :disabled="newPinConfirm !== newPin ||
                newPin.length < 6 ||
                newPin.length > 6 ||
                newPinConfirm.length < 6 ||
                newPinConfirm.length > 6 ||
                newPinConfirm === '' ||
                newPin === ''
                ">
                {{ $t("message.changePin") }}
              </v-btn>
            </v-col>
          </div>
          <!-- <div style="display: flex;justify-content: center;">
            <div class="mr-4" :style="'width: 9px;border-radius: 111px;padding: 11px;background-color:' + count1() + 'border: solid 2px grey;'"></div>
            <div class="mr-4" :style="'width: 9px;border-radius: 111px;padding: 11px;background-color:' + count2() + 'border: solid 2px grey;'"></div>
            <div class="mr-4" :style="'width: 9px;border-radius: 111px;padding: 11px;background-color:' + count3() + 'border: solid 2px grey;'"></div>
            <div class="mr-4" :style="'width: 9px;border-radius: 111px;padding: 11px;background-color:' + count4() + 'border: solid 2px grey;'"></div>
            <div class="mr-4" :style="'width: 9px;border-radius: 111px;padding: 11px;background-color:' + count5() + 'border: solid 2px grey;'"></div>
            <div :style="'width: 9px;border-radius: 111px;padding: 11px;background-color:' + count6() + 'border: solid 2px grey;'"></div>
        </div> -->
          <!-- <v-divider></v-divider> -->
        </v-card>
      </v-dialog>
      <!-- dialog reset pin -->
      <div v-if="checkFooterColorByLevel(shopId)">
        <div v-if="showMenu" style="width:100%">
          <v-footer app padless v-if="
            $route.name !== 'MemberShop' &&
            $route.name !== 'PrivacyNotice' &&
            $route.name !== 'Login' &&
            $route.name !== 'StampCard' &&
            $route.name !== 'BvpQuestion'
          ">
            <v-card width="100%" style="padding: 10px;" v-if="
              $route.name !== 'RegisterMember' ||
              (findUser === false &&
                $route.query.type === 'welcome' &&
                $route.name === 'home')
            ">
              <v-card-text style="display: flex;justify-content: space-around;">
                <transition appear name="fade-slide">
                  <v-btn icon >
                    <div class="d-flex align-items-center flex-column" style="flex-direction: row ;">
                      <div @click="$router.push('/C').catch(() => { })" :class="
                        (!isTargetShop && $route.path.startsWith('/C/reward'))
                          ? 'menu_active_LMG'
                          : ($route.path === '/C' || $route.path === '/CLYN' || $route.name === 'root' || !$route.name || $route.path === '/C/promotion')
                            ? 'menu_active_LMG'
                            : ''
                      " :style="{
                        '--vat_lmg': $bgColor,
                        '--color_img': isTargetShop ? '#ffa300' : HEXToVBColorLMG($bgColor)
                      }">
                        <img width="20" :src="
                          (!isTargetShop && $route.path.startsWith('/C/reward'))
                            ? (HEXTHEMELMG($bgColor) ? $images.homeActive : $images.home)
                            : ($route.path === '/C' || $route.path === '/CLYN' || $route.name === 'root' || !$route.name || $route.path === '/C/promotion')
                              ? (HEXTHEMELMG($bgColor) ? $images.homeActive : $images.home)
                              : $images.home
                        " size="29px" />
                      </div>
                      <p style="margin-bottom: 0;letter-spacing: 0px;" :style="{
                              '--vat_lmg': $bgColor,
                              '--color_img': isTargetShop ? '#ffa300' : HEXToVBColorLMG($bgColor),
                              'color': isTargetShop ? (($route.path === '/C' || $route.path === '/CLYN' || $route.name === 'root' || !$route.name || $route.path === '/C/promotion') ? '#ffa300' : '#000') : (((!isTargetShop && $route.path.startsWith('/C/reward')) || $route.path === '/C' || $route.path === '/CLYN' || $route.name === 'root' || !$route.name || $route.path === '/C/promotion') ? menuTextColor : menuTextColor)
                            }">
                        {{ $t("message.home") }}
                      </p>
                    </div>
                  </v-btn>
                </transition>

                <transition appear name="fade-slide">
                  <v-btn  icon >
                    <div class="d-flex align-items-center flex-column" style="flex-direction: row ;">
                      <div @click="$router.push('/C/card')" :class="
                        (isTargetShop && $route.path.startsWith('/C/reward'))
                          ? 'menu_active_LMG'
                          : ($route.path === '/C/card' || $route.path === '/C/privilege' || $route.path === '/C/NewMyReward' || $route.path === '/C/TierBenefit' || $route.path === '/C/transaction' || $route.path === '/C/level' || $route.path === '/C/MyPackage' || $route.path === '/C/tierBenefit' || $route.path.startsWith('/C/MyPoints'))
                            ? 'menu_active_LMG'
                            : 'menu_LMG'
                      " :style="{
                        '--vat_lmg': $bgColor,
                        '--color_img': isTargetShop ? '#ffa300' : HEXToVBColorLMG($bgColor)
                      }">
                        <img width="20" :src="
                          (isTargetShop && $route.path.startsWith('/C/reward'))
                            ? (HEXTHEMELMG($bgColor) ? $images.accountWhite : $images.accountBlack)
                            : ($route.path === '/C/card' || $route.path === '/C/privilege' || $route.path === '/C/NewMyReward' || $route.path === '/C/TierBenefit' || $route.path === '/C/transaction' || $route.path === '/C/level' || $route.path === '/C/MyPackage' || $route.path === '/C/tierBenefit'|| $route.path.startsWith('/C/MyPoints'))
                              ? (HEXTHEMELMG($bgColor) ? $images.accountWhite : $images.accountBlack)
                              : $images.accountBlack
                        " size="29px" />
                      </div>
                      <p style="margin-bottom: 0;letter-spacing: 0px;"
                        :style="{ 'color': isTargetShop ? ((($route.path === '/C/card' || $route.path === '/C/privilege' || $route.path === '/C/NewMyReward' || $route.path === '/C/TierBenefit' || $route.path === '/C/transaction' || $route.path === '/C/level' || $route.path === '/C/MyPackage' || $route.path.startsWith('/C/MyPoints') || $route.path === '/C/tierBenefit' || $route.path.startsWith('/C/reward'))) ? '#ffa300' : '#000') : menuTextColor }">
                        {{ $t("message.account") }}
                      </p>
                    </div>
                  </v-btn>
                </transition>

                <transition appear name="fade-slide">
                  <v-btn  icon >
                    <div class="d-flex align-items-center flex-column" style="flex-direction: row ;">
                      <div @click="$router.push('/C/activity').catch(() => { })" :class="$route.path === '/C/activity' ||
                          $route.path === '/C/activityDetail' ||
                          $route.path === '/C/FriendGetFriend'
                          ? 'menu_active_LMG'
                          : 'menu_LMG'
                        " :style="{
                          '--vat_lmg': $bgColor,
                          '--color_img': isTargetShop ? '#ffa300' : HEXToVBColorLMG($bgColor)
                        }">
                        <img width="20" :src="$route.path === '/C/activity' ||
                            $route.path === '/C/activityDetail' ||
                            $route.path === '/C/FriendGetFriend'
                            ? HEXTHEMELMG($bgColor)
                              ? $images.activityWhite
                              : $images.activityBlack
                            : $images.activityBlack
                          " size="24px" />
                      </div>
                      <p style="margin-bottom: 0;letter-spacing: 0px;"
                        :style="{ 'color': isTargetShop ? (($route.path === '/C/activity' || $route.path === '/C/activityDetail' || $route.path === '/C/FriendGetFriend') ? '#ffa300' : '#000') : menuTextColor }">
                        {{ $t("message.activity") }}
                      </p>
                    </div>
                  </v-btn>
                </transition>

                <transition appear name="fade-slide">
                  <v-btn  icon >
                    <div class="d-flex align-items-center flex-column" style="flex-direction: row ;">
                      <div @click="$router.push('/C/account').catch(() => { })" :class="$route.path === '/C/account' ||
                          $route.path === '/C/Mybranch'
                          ? 'menu_active_LMG'
                          : 'menu_LMG'
                        " :style="{
                          '--vat_lmg': $bgColor,
                          '--color_img': isTargetShop ? '#ffa300' : HEXToVBColorLMG($bgColor)

                        }">
                        <img width="20" :src="$route.path === '/C/account' ||
                            $route.path === '/C/Mybranch'
                            ? HEXTHEMELMG($bgColor)
                              ? $images.mapWhite
                              : $images.mapBlack
                            : $images.mapBlack
                          " size="29px" />
                      </div>
                      <p style="margin-bottom: 0;letter-spacing: 0px;"
                        :style="{ 'color': isTargetShop ? (($route.path === '/C/account' || $route.path === '/C/Mybranch') ? '#ffa300' : '#000') : menuTextColor }">
                        {{ $t("message.contact") }}
                      </p>
                    </div>
                  </v-btn>
                </transition>
              </v-card-text>
            </v-card>
          </v-footer>
        </div>
      </div>
      <div v-else>
        <div v-if="showMenu" style="width:100%">
          <v-footer app padless v-if="
            $route.name !== 'MemberShop' &&
            $route.name !== 'PrivacyNotice' &&
            $route.name !== 'Login' &&
            $route.name !== 'StampCard' &&
            $route.name !== 'BvpQuestion' &&
            $route.name !== 'StampRXTradex'
          ">
            <v-card width="100%" style="padding: 10px;" v-if="
              $route.name !== 'RegisterMember' ||
              (findUser === false &&
                $route.query.type === 'welcome' &&
                $route.name === 'home')
            ">
              <v-card-text style="display: flex;justify-content: space-around;">
                <transition appear name="fade-slide">
                  <v-btn icon >
                    <div style="flex-direction: row ;">
                      <div>
                        <v-icon size="29px" :class="$route.name === 'home' ||
                            $route.name === 'CLYN' ||
                            $route.name === 'root' ||
                            !$route.name ||
                            $route.name === 'reward'
                            ? 'menu_active'
                            : ''
                          " @click="$router.push('/').catch(() => { })">
                          mdi-home
                        </v-icon>
                      </div>
                      <p style="margin-bottom: 0;letter-spacing: 0px;">
                        {{ $t("message.home") }}
                      </p>
                    </div>
                  </v-btn>
                </transition>

                <transition appear name="fade-slide" v-if="!this.$isEventShop(shopId)">
                  <v-btn  icon >
                    <div style="flex-direction: row ;">
                      <div>
                        <v-icon size="29px" :class="$route.name === 'card' ||
                            $route.name === 'privilege' ||
                            $route.name === 'TierBenefit' ||
                            $route.name === 'transaction' ||
                            $route.name === 'level' ||
                            $route.name === 'MyPackage'
                            ? 'menu_active'
                            : ''
                          " @click="$router.push('/card').catch(() => { })">
                          mdi-account-circle
                        </v-icon>
                      </div>
                      <p style="margin-bottom: 0;letter-spacing: 0px;">
                        {{ $t("message.account") }}
                      </p>
                    </div>
                  </v-btn>
                </transition>

                <!-- <v-btn    icon>
                  <div style="flex-direction: row ;">
                    <div>
                      <v-icon size="22px" :class="($route.name === 'qrcodescan') ? 'menu_active' : ''" @click="scanCodeV2()">
                        mdi-qrcode-scan
                      </v-icon>
                    </div>
                  </div>
                </v-btn> -->

                <transition appear name="fade-slide">
                  <v-btn  icon >
                    <div style="flex-direction: row ;">
                      <div>
                        <v-icon size="24px" :class="$route.name === 'activity' ||
                            $route.name === 'activityDetail' ||
                            $route.name === 'FriendGetFriend'
                            ? 'menu_active'
                            : ''
                          " @click="$router.push('/activity').catch(() => { })">
                          mdi-gift
                        </v-icon>
                      </div>
                      <p style="margin-bottom: 0;letter-spacing: 0px;">
                        {{ $t("message.activity") }}
                      </p>
                    </div>
                  </v-btn>
                </transition>

                <transition appear name="fade-slide" v-if="!this.$isEventShop(shopId)">
                  <v-btn  icon >
                    <div style="flex-direction: row ;">
                      <div>
                        <v-icon size="29px" :class="$route.name === 'account' ||
                            $route.name === 'Mybranch'
                            ? 'menu_active'
                            : ''
                          " @click="$router.push('/account').catch(() => { })">
                          mdi-store
                        </v-icon>
                      </div>
                      <p style="margin-bottom: 0;letter-spacing: 0px;">
                        {{ $t("message.contact") }}
                      </p>
                    </div>
                  </v-btn>
                </transition>
              </v-card-text>
            </v-card>
          </v-footer>
        </div>
      </div>
      <v-footer app v-if="$route.name === 'MemberShop'">
        <v-card flat tile width="100%" class="lighten-1 text-center">
          <v-row justify="center" no-gutters>
            <v-col class="betask-bg lighten-2 py-3 text-center" cols="12">
              {{ new Date().getFullYear() }} — <strong>BeTask</strong>
            </v-col>
          </v-row>
        </v-card>
      </v-footer>
    </v-main>
    <v-footer app v-if="$route.name === 'MemberShop'">
      <v-card flat tile width="100%" class="lighten-1 text-center">
        <v-row justify="center" no-gutters>
          <v-col class="betask-bg lighten-2 py-3 text-center" cols="12">
            {{ new Date().getFullYear() }} — <strong>BeTask</strong>
          </v-col>
        </v-row>
      </v-card>
    </v-footer>
    <!-- <div :style="themeStyle"> -->
    <!-- </div> -->
  </v-app>
</template>
<script>
// import store from './store'
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'
import { resolveLoyaltyLiffLoginId, liffLoginShopId } from '@/utils/liffLogin'
import Vue from 'vue'
import Swal from 'sweetalert2'
// import { initializeApp } from 'firebase/app'
// import Swal from 'sweetalert2'

export default {
  name: 'App',
  // metaInfo: {
  //   meta: [
  //     { property: `og:title`, content: 'My Custom Open Graph Title App' },
  //     { property: 'og:image', content: 'https://storage.googleapis.com/betask-linked/static/upload/Shop/SH261_20221229231505684117.jpeg' }
  //   ]
  // },
  // beforeCreate () {
  //   if (typeof this.$route.query.liffId !== 'undefined') {
  //     store.commit('lineStore/SET_LIFFID', this.$route.query.liffId)
  //   }
  //   this.$session.remove('shopPrompt')
  // },
  data () {
    return {
      levelById: null,
      widthScreen: window.screen.width,
      // size1: 'mx-0',
      // size2: 'mx-3',
      // size3: 'mx-4',
      // icons: [
      //   'mdi-home',
      //   'mdi-email',
      //   'mdi-calendar',
      //   'mdi-delete'
      // ],
      loaded: false,
      branchId: null,
      masBranchName: null,
      checkLiffBranch: false,
      profile: null,
      member: null,
      lineUserIds: null,
      liffUserIds: null,
      memberId: null,
      tel: '',
      findUser: false,
      dataMember: null,
      shopId: null,
      showMenu: false,
      liffId2: null,
      thai:
        'https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2Fflag-TH.png?alt=media&token=e4bd7ffa-aed9-47e3-9240-4dcb9d8d284e',
      eng:
        'https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2Fflag-USA1.png?alt=media&token=a83dd820-f576-457a-8d08-1009cea9d70b',
      validAdd: false,
      shopId2: '',
      loadingBtn: false,
      type: '',
      dialogConfirmMember: false,
      loginTel: true,
      dialogPin: false,
      pin_number: '',
      overlay: false,
      dialogOTP: false,
      otpPassword: '',
      dialogResetPin: false,
      newPinConfirm: '',
      heigthScreen: null,
      newPin: '',
      logo: null,
      shopName: '',
      rules: {
        numberRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: value => value.length === 10 || 'Max 10 characters',
        IDcardRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: value => !!value || 'กรุณากรอก.',
        counterIDcard: value => value.length <= 13 || 'Max 13 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      images: {
        point:
          'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/activity/ACT3791_20250306092811679901.png'
      }
    }
  },
  // computed: {
  // metaInfo () {
  //   return {
  //     meta: [
  //       {
  //         property: 'og:title',
  //         content: this.pageTitle
  //       },
  //       {
  //         property: 'og:image',
  //         content: this.pageImage
  //       }
  //     ]
  //   }
  // },
  // trrr () {
  //   return this.GET_MEMBERINFO()
  // }
  // },
  computed: {
    newData () {
      return this.GET_MEMBERINFO()
    },
    // Keep a reactive handle to the theme so we can watch changes
    theme () {
      return this.GET_THEME()
    },
    isTargetShop () {
      return this.$isTargetShop()
    },
    chipTextColor () {
      return this.isTargetShop ? '#000' : (this.HEXTHEMELMGLog(this.$bgColor) ? '#FFF' : this.$bgColor3)
    },
    pointIcon () {
      if (this.isTargetShop) {
        return this.$images.ChubbIconReward
      }
      if (this.checkpushCustom()) {
        return this.HEXTHEMELMG(this.$bgColor) ? this.$images.point : this.$images.pointWhite
      }
      return require('@/assets/coin.png')
    },
    menuTextColor () {
      return this.isTargetShop ? '#ffa300' : this.HEXToVBColorLMG(this.$bgColor)
    }
  },
  watch: {
    // When theme arrives or changes, override the global colors immediately
    theme (newTheme) {
      if (newTheme) {
        this.applyTheme(newTheme)
      }
    },
    // Watch for isTargetShop changes and update body class
    isTargetShop (newValue) {
      if (newValue) {
        document.body.classList.add('target-shop-font')
      } else {
        document.body.classList.remove('target-shop-font')
      }
    }
  },
  async beforeMount () {
    // Always call getMemberProfile before rendering
    await this.$store.dispatch('memberStore/getMemberProfile', {}, { root: true })
  },
  async mounted () {
    // Redundant call for safety, but beforeMount ensures it's loaded
    await this.$store.dispatch('memberStore/getMemberProfile', {}, { root: true })
    // description.setAttribute('content', 'Updated text')
    // let memberId = '111'
    // this.firestore = this.$firebase.firestore()
    // this.firestore.collection('PointRealTime').doc(memberId).onSnapshot((snapshot) => {
    //   if (snapshot.exists) {
    //     console.log('Document data:')
    //   } else {
    //     console.log('No such document!')
    //   }
    // }).catch((error) => {
    //   console.error('Error getting document:', error);
    // })
    await this.getShopAndcolor()
    // Ensure member info is loaded

    this.heigthScreen = window.innerHeight
    this.$CUSTOMMainTextColor = this.HEXToVBColorLMG(this.$CUSTOMMainTextColor)
    // await this.setNullMemberInfo()
    // var attr2 = document.querySelector("meta[property='og:title']").getAttribute("content")
    try {
      // console.log('isInClient', this.$liff.isInClient())
      this.shopId = await this.GET_SHOPID()

      // Apply Cordia New font for isTargetShop after shopId is loaded
      if (this.isTargetShop) {
        document.body.classList.add('target-shop-font')
      } else {
        document.body.classList.remove('target-shop-font')
      }
      // this.setShopId(this.$route.query.shopId)
      // await this.checkLiffLogin()
      if (this.$liff.isInClient()) {
        await this.checkLiffLogin()
      } else {
        // await this.checkLiffLogin()
        // barcode importOldMember
        const queryShopId = liffLoginShopId(this.$route.query)
        if (queryShopId) {
          if (queryShopId !== this.shopId) {
            this.setShopId(queryShopId)
            this.shopId = await this.GET_SHOPID()
          }
        }
        await this.getShopAndcolor()
        // this.logo.importData
        // document.description = this.logo.name
        this.shopName = this.logo.name
        document.title = this.logo.name
        // console.log('this.logo.name', document.title)
        if (
          this.logo.importData === 'True' &&
          this.logo.barCodeData === 'True' &&
          this.shopId
        ) {
          this.loaded = true
          this.$router.push('/Login?shopId=' + this.shopId)
        } else {
          if (this.logo.barCodeData !== 'True') {
            await this.checkLiffLogin()
          } else {
            // if (this.shopId !== 'SD_1770104911502' || this.shopId !== 'U9793e097e632d954bced75f0ad3610d2') {
            //   this.loaded = true
            //   if (this.shopId === 'Ub067d158c52aaaec79b67cfc997fda79') {
            //     await this.checkLiffLogin()
            //   }
            // } else {
            await this.checkLiffLogin()
            // }
          }
        }
      }
    } catch (err) {
      console.error(err)
    }
    this.showMenu = true
    await this.getLevelById()
    // console.log('$route::==>>', this.$router)
  },
  methods: {
    ...mapActions('lineStore', ['setProfile']),
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapActions('memberStore', ['setNullMemberInfo']),
    ...mapGetters('shopStore', ['GET_SHOPID', 'GET_THEME', 'GET_SHOPINFO']),
    ...mapActions('shopStore', ['getShopTheme', 'getShoppLevel', 'setShopId']),
    checkFooterColorByLevel (shopId) {
      if (shopId === this.shopNameData.chubb) {
        return true
      }
      return false
    },
    async getLevelById () {
      let member = this.GET_MEMBERINFO()
      if (!member || !member.levelId) {
        this.levelById = null
        return
      }
      const result = await this.callBeTaskAPI(
        'get',
        `/level/getID?RECORD_STATUS=N&levelId=${member.levelId}`
      )
      if (result) {
        this.levelById = result
      } else {
        this.levelById = null
      }
    },
    changlangue (lang) {
      // console.log(this.$i18n.locale)
      this.$i18n.locale = lang
    },
    async getShopAndcolor () {
      // console.log('shopStore/GET_SHOPID')
      try {
        if (this.$store.getters['shopStore/GET_SHOPID']) {
          await this.getShopTheme()
          const theme = this.GET_THEME()
          const infoShop = this.GET_SHOPINFO()
          this.logo = theme

          // ตั้งค่าชื่อหัว LIFF เป็นชื่อร้าน
          if (infoShop && (infoShop.title || infoShop.name)) {
            document.title = infoShop.title || infoShop.name
          }

          // console.log('this.logo', infoShop)
          await this.getTheme(theme)
          this.applyTheme(theme)

          // console.log('color', Vue.prototype.$bgColor)
          // await this.getShop()
        }
        await this.getShoppLevel()
      } catch (error) {
        console.error('getShopAndcolor', error)
      }
    },
    applyTheme (theme) {
      try {
        const colorHex = theme && theme.color1 ? theme.color1 : '#E0E0E0'
        const colorNoAlpha = colorHex.length > 7 ? colorHex.slice(0, -2) : colorHex
        Vue.prototype.$themecolor = colorHex
        Vue.prototype.$textcolor = this.HEXToVBColor(colorHex)
        Vue.prototype.$bgColor = this.hexToRgbA(colorNoAlpha)
        Vue.prototype.$bgColor2 = this.bgColor2(Vue.prototype.$bgColor)
        Vue.prototype.$bgColor3 = this.bgColor3(Vue.prototype.$bgColor2)
        Vue.prototype.$bgColorActivityCard = this.bgColorActivityCard(Vue.prototype.$bgColor)
        // Ensure the UI re-renders to pick up new prototype values
        this.$forceUpdate()
      } catch (e) {
        console.error('applyTheme error', e)
      }
    },
    async checkLostData (memberCard) {
      // console.log('KKE2', memberCard)
      try {
        // ถ้าเป็นร้าน ครัวกันเอง
        if (
          this.logo.importData === 'True' ||
          this.shopId === 'Uc850d4b60c5b51d3034e44ecf52e4687'
        ) {
          // console.log('KKE', memberCard)
          if (memberCard.data.status === false) {
            this.dialogConfirmMember = true
            // this.$router.push(`/RegisterMember?shopId=${this.$route.query.shopId}&tel=0909945736`)
          } else {
            this.dialogConfirmMember = false
          }
        } else {
          this.member = await this.callBeTaskAPI(
            'get',
            '/memberCard/line/get?shopId=' +
            this.shopId +
            '&memberId=' +
            this.profile.memberId
          )
          // console.log('app.vue11111111111', this.profile)
          this.shopId = this.GET_SHOPID()
          const currentUrl = window.location.pathname
          if (currentUrl !== '/PrivacyNotice') {
            this.member.status === false
              ? (this.findUser = false)
              : (this.findUser = true)
            // console.log('app.vue', this.member.status)
            // console.log('app.vueeee', !this.findUser && this.$route.query.shopId)
            this.dataMember = await this.callBeTaskAPI(
              'get',
              '/member/get?shopId=' +
              this.shopId +
              '&memberId=' +
              this.profile.memberId
            )
            if (
              !this.$route.query.type &&
              !this.$route.query.likeToken &&
              !this.$route.query.packageToken &&
              !this.$route.query.token
            ) {
              if (
                !this.findUser &&
                this.$route.query.shopId &&
                currentUrl !== '/RegisterMember'
              ) {
                const redirectUrl = encodeURIComponent(
                  currentUrl + window.location.search
                )
                if (this.branchId) {
                  this.$router.push(
                    `/RegisterMember?shopId=${this.$route.query.shopId}&redirectUrl=${redirectUrl}&branchId=${this.branchId}`
                  )
                } else {
                  this.$router.push(
                    `/RegisterMember?shopId=${this.$route.query.shopId}&redirectUrl=${redirectUrl}`
                  )
                }
                // this.$router.push(`/RegisterMember?shopId=${this.$route.query.shopId}&type=anotherlink&redirectUrl=${redirectUrl}`)
              }
              // มี memberCard แล้ว ให้คง path เดิมไว้ ไม่ต้อง redirect ไป /C หรือ /
              if (
                this.findUser &&
                  this.$route.query.shopId &&
                  currentUrl !== '/RegisterMember' &&
                  !this.$route.query.memberId
              ) {
                // ไม่ต้อง redirect หรือ replace path ใด ๆ ทั้งสิ้น
                // Stay on current path (e.g., /BuyPackage/596?shopId=...)
              } else {
              }
            }
          }
        }
      } catch (err) {
        console.error(err)
      }
    },
    async checkWelcome () {
      try {
        this.member = this.GET_MEMBERINFO()
        this.shopId = this.GET_SHOPID()
        this.member === null ? (this.findUser = false) : (this.findUser = true)
        if (this.$route.query.type === 'welcome') {
          // console.log('check type', this.profile.userId)
          if (this.findUser) {
            await axios
              .get(
                this.DNS_IP +
                '/member/get?shopId=' +
                this.$route.query.shopId +
                '&liffUserId=' +
                this.profile.userId
              )
              .then(async result => {
                // console.log('result//ffff/', typeof result.data.status)
                if (typeof result.data.status === 'undefined') {
                  this.lineUserIds = result.data[0].lineUserId || ''
                  this.liffUserIds = result.data[0].liffUserId || ''
                  this.memberId = result.data[0].memberId
                } else {
                  // console.log('this.kuy', this.member.memberId)
                  this.$router.push(
                    `/RegisterMember?shopId=${this.$route.query.shopId}&memberId=${this.member.memberId}`
                  )
                }
                if (this.lineUserIds === '' && this.liffUserIds !== '') {
                  // check empty lineUserId (modular)
                  if (this.$liff.isInClient()) {
                    this.$liff
                      .sendMessages([
                        {
                          type: 'text',
                          text:
                            'เปิดใช้งานบัตรสะสมแต้มเรียบร้อย หมายเลขสมาชิกของคุณคือ ' +
                            this.memberId
                        }
                      ])
                      .then(() => {
                      })
                      .catch(err => {
                        console.error('error', err)
                      })
                  } else {
                    console.error('ไม่เข้า')
                  }
                }
              })
          } else if (!this.findUser) {
            this.$router.push(
              `/RegisterMember?shopId=${this.$route.query.shopId}`
            )
          }
        }
      } catch (err) {
        console.error(err)
      }
    },
    async checkLiffLogin () {
      await this.checkLiffState()
      try {
        this.$liff
          .init({
            liffId: this.$liffId
            // withLoginOnExternalBrowser: true
          })
          .then(async () => {
            await this.getProfileMain()
            // alert('dddddd')
            let memberCard = await axios.get(
              this.DNS_IP +
              '/memberCard/get?shopId=' +
              this.shopId +
              '&lineUserId=' +
              this.profile.userId
            )
            if (this.branchId && memberCard.data.status === false) {
              memberCard = await axios.get(
                this.DNS_IP +
                '/lineUserID_Multi_Provider/get?shopId=' +
                this.shopId +
                '&lineUserId=' +
                this.profile.userId
              )
              if (Array.isArray(memberCard.data)) {
                await axios.post(
                  this.DNS_IP +
                  '/memberAndMemberCard/edit/' +
                  memberCard.data[0].memberId,
                  { liffUserId: this.profile.userId }
                )
              }
              // await axios.post(this.DNS_IP + '/memberAndMemberCard/edit/' + this.dataMember.memberId, {'liffUserId': this.profile.userId})
            }
            this.profile.displayName =
              memberCard.data.status === false
                ? this.profile.displayName
                : this.profile.displayName
            this.profile.pictureUrl =
              memberCard.data.status === false
                ? this.profile.pictureUrl
                : this.profile.pictureUrl
            this.profile.memberId =
              memberCard.data.status === false
                ? null
                : memberCard.data[0].memberId
            this.profile.userId =
              memberCard.data.status === false
                ? this.profile.userId
                : memberCard.data[0].lineUserId
            this.profile.tel =
              memberCard.data.status === false ? null : memberCard.data[0].tel
            // console.log('this.profileja', this.profile)
            // if (Array.isArray(memberCard)) {
            //   this.profile.memberId = memberCard[0].memberId
            //   this.profile.tel = memberCard[0].tel
            // }
            await this.setProfile(this.profile)
            await this.updateProfile()
            await this.checkLostData(memberCard)
            await this.checkWelcome()
            this.loaded = true
            if (this.member) {
              this.$i18n.locale = this.member.language
            }
            this.$showHome = true
          })
          .catch(err => {
            console.error('aaaaa', err)
          })
        // alert('finisdhInit2')
      } catch (err) {
        console.error('cccccc', err)
      }
    },
    async updateProfile () {
      try {
        this.member = this.GET_MEMBERINFO()
        // console.log('updateProfile', this.member)
        // console.log('updateProfile', this.profile)
        if (this.member) {
          await axios.post(
            this.DNS_IP + `member/edit/${this.member.memberId}`,
            {
              name: this.profile.displayName.replace(/'/g, "\\'"),
              picture: this.profile.pictureUrl
            }
          )
        }
      } catch (err) {
        console.error(err)
      }
    },
    async getProfileMain () {
      // alert('getProfileMain')
      try {
        await this.$liff.ready.then(async () => {
          // alert('$liff.ready')
          if (process.env.NODE_ENV === 'development') {
            this.getProfile_dev()
          } else {
            if (!this.$liff.isLoggedIn()) {
              // alert('!this.$liff.isLoggedIn()')
              await this.$liff.login({ redirectUri: window.location.href })
            } else {
              // alert('getProfile')
              await this.getProfile()
              // if (this.$route.query['liff.state']) {
              //   this.$router.push(this.$route.query['liff.state'])
              // }
            }
          }
        })
      } catch (err) {
        console.error('getProfileMain error js', err)
      }
    },
    async getProfile () {
      try {
        let _this = this
        await this.$liff
          .getProfile()
          .then(function (profile) {
            // alert(profile)
            profile.pictureUrl =
              profile.pictureUrl ||
              'https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/user.png?alt=media&token=b9e270ee-8367-489f-8693-03499508dcd2'
            _this.profile = profile
          })
          .catch(function (error) {
            console.error('Error getting profile: ' + error)
          })
      } catch (err) {
        console.error(err)
      }
    },
    getProfile_dev () {
      this.profile = this.$profile_dev
      this.profile.pictureUrl =
        this.profile.pictureUrl ||
        'https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/user.png?alt=media&token=b9e270ee-8367-489f-8693-03499508dcd2'
      // console.log('getProfile_dev', this.profile)
    },

    async scanCodeV2 () {
      await this.$liff
        .init({
          liffId: this.$liffId
          // withLoginOnExternalBrowser: true
        })
        .then(async () => {
          await this.$liff.ready.then(async () => {
            if (process.env.NODE_ENV === 'development') {
            } else {
              if (!this.$liff.isLoggedIn()) {
                await this.$liff.login({ redirectUri: window.location.href })
              } else {
                try {
                  const result = await this.$liff.scanCodeV2()
                  // console.log('scanCodeV2', result.value)
                  // document.querySelector('#result').innerHTML = result.value
                  window.location.href = result.value
                } catch (error) {
                  console.error('scanCodeV2', error)
                }
              }
            }
          })
        })
        .catch(err => {
          // this.$router.push({ name: '404' })
          console.error(err.code, err.message)
        })
    },

    hexToRgbA (hex) {
      var c
      // if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split('')
      if (c.length === 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]]
      }
      c = '0x' + c.join('')
      return (
        'rgb(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ')'
      )
      // }
      // throw new Error('Bad Hex')
    },

    bgColor2 (rgb) {
      // console.log('rgb', rgb)
      var c = rgb
        .slice(3)
        .slice(1, -1)
        .split(',')
      // console.log('ddddds', c)
      return (
        'rgb(' +
        (parseInt(c[0]) + 70) +
        ',' +
        (parseInt(c[1]) + 70) +
        ',' +
        (parseInt(c[2]) + 70) +
        ')'
      )
    },
    bgColor3 (rgb) {
      // console.log('rgb', rgb)
      var c = rgb
        .slice(3)
        .slice(1, -1)
        .split(',')
      // console.log('ddddds', c)
      return (
        'rgb(' +
        (parseInt(c[0]) + 70) +
        ',' +
        (parseInt(c[1]) + 70) +
        ',' +
        (parseInt(c[2]) + 70) +
        ', 0.3)'
      )
    },

    bgColorActivityCard (rgb) {
      // console.log('rgb', rgb)
      var c = rgb
        .slice(3)
        .slice(1, -1)
        .split(',')
      // console.log('ddddds3333', c)
      return 'rgb(' + c[0] + ',' + c[1] + ',' + c[2] + ', 0.7)'
    },
    async checkLiffState () {
      const queryString = decodeURIComponent(window.location.search).replace(
        '?liff.state=',
        ''
      )
      const value = new URLSearchParams(queryString.substring(6))
      this.shopId2 = value.get('shopId') || value.get('sourceShopId')
      this.branchId = value.get('branchId')
      this.type = value.get('type')
      if (this.$route.query.shopId || this.$route.query.sourceShopId) {
        this.shopId2 = this.$route.query.shopId || this.$route.query.sourceShopId
        this.branchId = this.$route.query.branchId
        // this.$showHome = true
      } else {
        const queryString = decodeURIComponent(window.location.search).replace(
          '?liff.state=',
          ''
        )
        // console.log('queryString', typeof queryString)
        const value = new URLSearchParams(queryString.split('?')[1])
        // console.log('shopidddfdfdfdfdfdfdf', value.get('shopId'))
        this.shopId2 = value.get('shopId') || value.get('sourceShopId')
        this.branchId = value.get('branchId')
        if (!this.shopId2) {
          this.shopId2 = this.shopId
        }
        // this.$showHome = false
      }
      if (!this.$liff.isInClient()) {
        const loginLiffId = await resolveLoyaltyLiffLoginId(this.DNS_Migrate, this.shopId2)
        if (loginLiffId) {
          this.$liffId = loginLiffId
          return
        }
      }
      const result = await axios.get(
        this.DNS_Link + `/lineconfig/get?shopId=${this.shopId2}`
      )
      if (Array.isArray(result.data)) {
        if (result.data[0].liffMainIDLoyalty !== null) {
          this.$liffId = result.data[0].liffMainIDLoyalty
        } else {
          this.$liffId = '1656906322-JN5MM8Ep'
        }
      } else {
        if (this.branchId) {
          const resultBranch = await axios.get(
            this.DNS_IP +
            `/master_branch/get?shopId=${this.shopId2}&masBranchID=${this.branchId}`
          )
          if (
            resultBranch.data[0].liffMainIDLoyalty !== null &&
            resultBranch.data[0].liffMainIDLoyalty !== '' &&
            resultBranch.data[0].liffMainIDLoyalty !== 'None'
          ) {
            this.$liffId = resultBranch.data[0].liffMainIDLoyalty
            this.masBranchName = resultBranch.data[0].masBranchName
          } else {
            this.$liffId = '1656906322-JN5MM8Ep'
          }
        } else {
          this.$liffId = '1656906322-JN5MM8Ep'
        }
      }
      // // alert(this.shopId2)
      // // alert(this.$liffId)
      // console.log('tototototototo', this.$liffId)
    },
    async checkIsmember () {
      this.loadingBtn = true
      await axios
        .get(
          this.DNS_IP +
          '/member/get?shopId=' +
          this.$route.query.shopId +
          '&tel=' +
          this.tel
        )
        .then(async result => {
          if (this.shopId === 'Uc850d4b60c5b51d3034e44ecf52e4687') {
            if (result.data.status === undefined) {
              this.loadingBtn = false
              Swal.fire({
                title: '<h5>' + `หมายเลขนี้มีผู้ใช้งานแล้ว` + '</h5>',
                icon: 'error',
                showCancelButton: false,
                allowOutsideClick: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#b3b1ab',
                confirmButtonText: `${this.$t('message.confirm')}`
              })
            } else {
              let dataOdoo = await axios.post(this.DNS_IP + '/NPD/CheckOdoo', {
                tel: this.tel
              })
              if (dataOdoo.data.status === false) {
                this.loadingBtn = false
                Swal.fire({
                  html: `<h5>ไม่พบข้อมูลของท่านในระบบ กรุณาติดต่อเจ้าหน้าที่สาขา กดเพื่อติดต่อ 👉 <a href="https://lin.ee/E6LoalV" target="_blank">https://lin.ee/E6LoalV</a></h5>`,
                  icon: 'error',
                  showCancelButton: false,
                  allowOutsideClick: false,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#b3b1ab',
                  confirmButtonText: `${this.$t('message.confirm')}`
                })
              } else {
                this.dialogConfirmMember = false
                this.$router.push(
                  `/RegisterMember?shopId=${this.shopId}&tel=${this.tel}&odooId=${dataOdoo.data.odoo_id}`
                )
              }
            }
            // let dataOdoo = await axios.get(this.DNS_IP + '/member/get?shopId=')
          } else {
            if (result.data.status === undefined) {
              this.dataMember = result.data[0]
              if (this.logo.otpConfirm === 'True') {
                this.dialogPin = true
              } else {
                // update data
                if (
                  this.dataMember.liffUserId === null ||
                  this.dataMember.liffUserId === ''
                ) {
                  await axios.post(
                    this.DNS_IP +
                    '/memberAndMemberCard/edit/' +
                    this.dataMember.memberId,
                    { liffUserId: this.profile.userId }
                  )
                  const currentUrl = window.location.pathname
                  if (currentUrl === '/level') {
                    window.location = '/level?shopId=' + this.shopId
                  } else {
                    window.location = '/home?shopId=' + this.shopId
                  }
                } else {
                  this.loadingBtn = false
                  Swal.fire({
                    title: '<h5>' + `${this.$t('message.fail')}` + '</h5>',
                    text: `${this.$t('message.telIsLinkedLineId')}`,
                    icon: 'error',
                    showCancelButton: false,
                    allowOutsideClick: false,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#b3b1ab',
                    confirmButtonText: `${this.$t('message.confirm')}`
                  })
                }
              }
            } else {
              if (this.branchId) {
                // การตั้งค่า สาขา คนละ line oa liff
                let res = await axios.get(
                  this.DNS_IP +
                  '/lineUserID_Multi_Provider/get?shopId=' +
                  this.shopId +
                  '&tel=' +
                  this.tel
                )
                if (Array.isArray(res.data)) {
                  // alert('เจอ')
                  // alert('alert1')
                  this.dialogPin = true
                } else {
                  let res = await axios.get(
                    this.DNS_IP +
                    '/importData/line/get?shopId=' +
                    this.shopId +
                    '&tel=' +
                    this.tel
                  )
                  if (Array.isArray(res.data)) {
                    sessionStorage.setItem('info', JSON.stringify(res.data[0]))
                    this.profile.tel = this.tel
                    await this.setProfile(this.profile)
                    this.dialogConfirmMember = false
                    const currentUrl = window.location.pathname
                    const redirectUrl = encodeURIComponent(
                      currentUrl + window.location.search
                    )
                    this.$router.push(
                      `/RegisterMember?shopId=${this.$route.query.shopId}&tel=${this.tel}&branchId=${this.branchId}&importData=true&branchId=${this.branchId}&redirectUrl=${redirectUrl}`
                    )
                  } else {
                    Swal.fire({
                      title:
                        '<h5>' + this.$t('message.notMemberAndRegis') + '</h5>',
                      showCancelButton: true,
                      allowOutsideClick: false,
                      confirmButtonColor: '#3085d6',
                      cancelButtonColor: '#b3b1ab',
                      confirmButtonText: `${this.$t('message.regisMember')}`,
                      cancelButtonText: `${this.$t('message.cancle')}`
                    }).then(async confirm => {
                      if (confirm.isConfirmed) {
                        this.profile.tel = this.tel
                        await this.setProfile(this.profile)
                        this.dialogConfirmMember = false
                        const currentUrl = window.location.pathname
                        const redirectUrl = encodeURIComponent(
                          currentUrl + window.location.search
                        )
                        this.$router.push(
                          `/RegisterMember?shopId=${this.$route.query.shopId}&tel=${this.tel}&branchId=${this.branchId}&redirectUrl=${redirectUrl}`
                        )
                      } else {
                        this.loadingBtn = false
                      }
                    })
                  }
                }
              } else {
                // ไม่มีการตั้งค่า สาขา คนละ line oa liff
                let res = await axios.get(
                  this.DNS_IP +
                  '/importData/line/get?shopId=' +
                  this.shopId +
                  '&tel=' +
                  this.tel
                )
                if (Array.isArray(res.data)) {
                  sessionStorage.setItem('info', JSON.stringify(res.data[0]))
                  this.profile.tel = this.tel
                  await this.setProfile(this.profile)
                  this.dialogConfirmMember = false
                  const currentUrl = window.location.pathname
                  const redirectUrl = encodeURIComponent(
                    currentUrl + window.location.search
                  )
                  this.$router.push(
                    `/RegisterMember?shopId=${this.$route.query.shopId}&tel=${this.tel}&redirectUrl=${redirectUrl}&importData=true`
                  )
                } else {
                  Swal.fire({
                    title:
                      '<h5>' + this.$t('message.notMemberAndRegis') + '</h5>',
                    showCancelButton: true,
                    allowOutsideClick: false,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#b3b1ab',
                    confirmButtonText: `${this.$t('message.regisMember')}`,
                    cancelButtonText: `${this.$t('message.cancle')}`
                  }).then(async confirm => {
                    if (confirm.isConfirmed) {
                      this.profile.tel = this.tel
                      await this.setProfile(this.profile)
                      this.dialogConfirmMember = false
                      const currentUrl = window.location.pathname
                      const redirectUrl = encodeURIComponent(
                        currentUrl + window.location.search
                      )
                      this.$router.push(
                        `/RegisterMember?shopId=${this.$route.query.shopId}&tel=${this.tel}&redirectUrl=${redirectUrl}`
                      )
                    } else {
                      this.loadingBtn = false
                    }
                  })
                }
              }
            }
          }
        })
    },
    async inputPin (num) {
      if (this.pin_number.length > 6) {
        // console.log('เกิน')
      } else {
        this.pin_number = this.pin_number + num
        if (this.pin_number.length === 6) {
          if (this.branchId) {
            let data = {
              pin_number: this.pin_number,
              shopId: this.$route.query.shopId,
              tel: this.tel === null ? this.memberStore.tel : this.tel
            }
            await axios
              .post(this.DNS_IP + '/member/get-app', data)
              .then(async result => {
                if (result.data.status === undefined) {
                  const params = {
                    tel: this.tel
                      .split('-')
                      .join('')
                      .trim(),
                    memberId: this.dataMember.memberId,
                    lineUserId: this.profile.userId,
                    shopId: this.$route.query.shopId,
                    branchId: this.$route.query.branchId
                  }
                  await this.callBeTaskAPIActivity(
                    'post',
                    `/lineUserID_Multi_Provider/insert`,
                    params
                  )
                  await axios.post(
                    this.DNS_IP +
                    '/memberAndMemberCard/edit/' +
                    this.dataMember.memberId,
                    { liffUserId: this.profile.userId }
                  )
                  const currentUrl = window.location.pathname
                  if (currentUrl === '/level') {
                    window.location = '/level?shopId=' + this.shopId
                  } else {
                    location.reload()
                    // this.$router.push(`/home?shopId=${this.$route.query.shopId}`)
                  }
                } else {
                  this.overlay = false
                  this.pin_number = ''
                  Swal.fire({
                    title:
                      '<h5>' + `${this.$t('message.incorectPin')}` + '</h5>',
                    icon: 'error',
                    showCancelButton: false,
                    allowOutsideClick: false,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#b3b1ab',
                    confirmButtonText: `${this.$t('message.confirm')}`
                  }).then(async confirm => {
                    if (confirm.isConfirmed) {
                    }
                  })
                }
              })
              .catch(error => console.error(error))
          } else {
            this.overlay = true
            let data = {
              pin_number: this.pin_number,
              shopId: this.$route.query.shopId,
              tel: this.tel === null ? this.memberStore.tel : this.tel
            }
            await axios
              .post(this.DNS_IP + '/member/get-app', data)
              .then(async result => {
                if (result.data.status === undefined) {
                  if (
                    this.dataMember.liffUserId === null ||
                    this.dataMember.liffUserId === ''
                  ) {
                    await axios.post(
                      this.DNS_IP +
                      '/memberAndMemberCard/edit/' +
                      this.dataMember.memberId,
                      { liffUserId: this.profile.userId }
                    )
                    // alert(window.location.pathname)
                    // window.location = '/home?shopId=' + this.shopId
                    const currentUrl = window.location.pathname
                    if (currentUrl === '/level') {
                      window.location = '/level?shopId=' + this.shopId
                    } else {
                      window.location = '/home?shopId=' + this.shopId
                    }
                  } else {
                    Swal.fire({
                      title:
                        '<h5>' +
                        `${this.$t('message.linkAccountLine')}` +
                        '</h5>',
                      icon: 'error',
                      showCancelButton: false,
                      allowOutsideClick: false,
                      confirmButtonColor: '#3085d6',
                      cancelButtonColor: '#b3b1ab',
                      confirmButtonText: `${this.$t('message.confirm')}`
                    }).then(async confirm => {
                      if (confirm.isConfirmed) {
                        this.pin_number = ''
                        this.overlay = false
                        // this.profile.tel = this.tel
                        // await this.setProfile(this.profile)
                        // this.$router.push(`/RegisterMember?shopId=${this.$route.query.shopId}&tel=${this.tel}`)
                      }
                    })
                  }
                  // if (this.memberStore) {
                  //   this.$router.push('/home?shopId=' + this.shopId)
                  // } else {
                  // console.log('ffffdfdfdf', this.profile)
                  // this.overlay = false
                  // this.profile.tel = this.tel
                  // this.profile.memberId = this.dataMember.memberId
                  // this.profile.userId = this.dataMember.liffUserId || this.profile.userId
                  // this.profile.displayName = this.dataMember.name || this.dataMember.nameCustomer
                  // this.profile.pictureUrl = this.dataMember.picture || null
                  // this.profile.memberCardId = this.dataMember.memberCardId || null
                  // console.log('this.profileLogin', this.profile)
                  // await this.setProfile(this.profile)
                  // this.dialogConfirmMember = false
                  // this.dialogPin = false
                  // this.loaded = true
                  // }
                } else {
                  this.overlay = false
                  this.pin_number = ''
                  Swal.fire({
                    title:
                      '<h5>' + `${this.$t('message.incorectPin')}` + '</h5>',
                    icon: 'error',
                    showCancelButton: false,
                    allowOutsideClick: false,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#b3b1ab',
                    confirmButtonText: `${this.$t('message.confirm')}`
                  }).then(async confirm => {
                    if (confirm.isConfirmed) {
                      // this.profile.tel = this.tel
                      // await this.setProfile(this.profile)
                      // this.$router.push(`/RegisterMember?shopId=${this.$route.query.shopId}&tel=${this.tel}`)
                    }
                  })
                }
              })
          }
        }
      }
    },
    count1 () {
      return this.pin_number.length > 0 ? '#349aff;' : 'white;'
    },
    count2 () {
      return this.pin_number.length >= 2 ? '#349aff;' : 'white;'
    },
    count3 () {
      return this.pin_number.length >= 3 ? '#349aff;' : 'white;'
    },
    count4 () {
      return this.pin_number.length >= 4 ? '#349aff;' : 'white;'
    },
    count5 () {
      return this.pin_number.length >= 5 ? '#349aff;' : 'white;'
    },
    count6 () {
      return this.pin_number.length >= 6 ? '#349aff;' : 'white;'
    },
    deletePin () {
      this.pin_number = this.pin_number.slice(0, -1)
    },
    async createOtp () {
      const result = await axios.post(this.DNS_IP + `/OTP/resetpin`, {
        tel: this.tel
          .split('-')
          .join('')
          .trim(),
        shopId: this.shopId,
        language: this.$i18n.locale
      })
      if (result) {
        this.dialogOTP = true
      }
    },
    async otpCheck () {
      const data = await axios.get(
        this.DNS_IP +
        `/otp/get?tel=${this.tel
          .split('-')
          .join('')
          .trim()}`
      )
      if (data.data[0].otpPassword === this.otpPassword) {
        this.dialogOTP = false
        this.dialogResetPin = true
      }
    },
    async changeNewPin () {
      try {
        const data = await axios.post(
          this.DNS_IP + `/member/edit/${this.dataMember.memberId}`,
          { pin_number: this.newPinConfirm }
        )
        if (data) {
          Swal.fire({
            title: '<h5>' + `${this.$t('message.changePinSucces')}` + '</h5>',
            text: `${this.$t('message.newPinIs')}` + this.newPinConfirm,
            icon: 'success',
            showCancelButton: false,
            allowOutsideClick: false,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#b3b1ab',
            confirmButtonText: `${this.$t('message.confirm')}`
          }).then(async confirm => {
            if (confirm.isConfirmed) {
              this.dialogResetPin = false
              // this.profile.tel = this.tel
              // await this.setProfile(this.profile)
              // this.$router.push(`/RegisterMember?shopId=${this.$route.query.shopId}&tel=${this.tel}`)
            }
          })
        }
      } catch (error) {
        console.error('error', error)
      }
      // console.log(this.dataMember)
      // console.log(this.profile)
    },
    async callBeTaskAPIActivity (method, url, params) {
      let result = null
      //   const token = this.$liff.getAccessToken() || '1234567890'
      await axios({
        method: method,
        // headers: {
        //   accessToken: token,
        //   lineUserId: this.profile.userId,
        //   activityId: this.formUpdate.activityId
        // },
        url: this.DNS_IP + url,
        data: params
      })
        .then(response => {
          result = response.data
        })
        .catch(error => {
          console.error(error)
          result = null
        })
      return result
    },
    HEXTHEMELMG (hex) {
      if (!/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(hex)) {
        return true
      }

      let rr = parseInt(hex.substring(1, 3), 16)
      let gg = parseInt(hex.substring(3, 5), 16)
      let bb = parseInt(hex.substring(5, 7), 16)

      let brightness = rr * 0.299 + gg * 0.587 + bb * 0.114

      return brightness > 180
    }
  }
}
</script>

<style>
body {
  font-family: Kanit !important;
  width: 100%;
  overflow-x: hidden;
  overflow: auto;
  border: 1px solid transparent;
  height: 100%;
  background-color: #fff ;
}

/* Default font for all text */
body .text-caption {
  font-family: kanit !important;
}

/* Override font for isTargetShop */
body.target-shop-font,
body.target-shop-font .v-application,
body.target-shop-font .v-application .text-h5,
body.target-shop-font .v-application .text-h6,
body.target-shop-font .text-caption {
  font-family: "Cordia New", sans-serif !important;
}

.v-ripple__container {
  opacity: 0 !important;
}

label {
  margin: 0px;
}

:root {
  --table-body-row-even: #b1c9ea;
  --table-body-row-odd: #ffffff;
}

#no-background-hover::before {
  background-color: transparent !important;
}

.betask-bg {
  background-color: #1b437c;
  color: #fff;
}

.betask-grey-bg {
  background-color: #d9dddc;
  color: #1b437c;
}

.v-application--wrap {
  background-color: #F2F2F2;
}

.v-application,
.v-application .text-h5,
.v-application .text-h6 {
  font-family: Kanit !important;
}

/* Override for target shop */
.target-shop-font .v-application,
.target-shop-font .v-application .text-h5,
.target-shop-font .v-application .text-h6 {
  font-family: "Cordia New", sans-serif !important;
  /* Kanit → load มาจาก Google Fonts → มีทุก platform ✅
  Cordia New → ไม่ได้ load → มีแค่บน Windows เท่านั้น ❌ mobile ไม่มี */
}

.v-data-table>.v-data-table__wrapper>table>tbody>tr:nth-child(even)>td {
  background: var(--table-body-row-even);
}

.v-data-table>.v-data-table__wrapper>table>tbody>tr:nth-child(odd)>td {
  background: var(--table-body-row-odd);
}

/* .v-menu__content>.v-list>.v-list-item:(odd) {background: var(--table-body-row-odd)} */
/* .v-list-item:nth-child(odd) {background: #EDEDED} */
.v-dialog {
  border-radius: 6px !important;
}

.v-slide-group__content {
  padding-left: 15px;
}

.menu_active {
  color: var(--color_icon1) !important;
}

.menu_active_LMG {
  /* background-color: var(--vat_lmg) !important; */
  padding: 5px;
  color: var(--color_img) !important;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.menu_LMG {
  /* background-color: #C0BFC0 !important; */
  padding: 5px;
  color: #ffffff !important;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.v-footer,
.v-card__text {
  padding: 0px !important;
}

.btn_headline1 {
  background-color: var(--color_headline1) !important;
  border-color: var(--color_headline1) !important;
  width: 100% !important;
}

.btn_subheadline1 {
  background-color: var(--color_subheadline1) !important;
  border-color: var(--color_subheadline1) !important;
  width: 100% !important;
}

.btn_icon1 {
  background-color: var(--color_icon1) !important;
  border-color: var(--color_icon1) !important;
  width: 100% !important;
}

.headline1 {
  color: var(--color_headline1) !important;
}

.headline1_bg {
  background-color: var(--color_headline1) !important;
  color: #ffffff;
}

.subheadline1 {
  color: var(--color_subheadline1) !important;
}

.icon1 {
  color: var(--color_icon1) !important;
}

.headline2 {
  color: var(--color_headline2) !important;
}

.subheadline2 {
  color: var(--color_subheadline2) !important;
}

.icon2 {
  color: var(--color_icon2) !important;
}

.picture {
  color: var(--color_picture) !important;
}

.headline2_bg {
  background-color: var(--color_headline2) !important;
}

.coin_icon::after {
  margin-left: 0px;
  margin-top: 5px;
  content: "";
  background-image: var(--coin_img);
  background-size: 25px 25px;
  display: inline-block;
  width: 25px;
  height: 25px;
  vertical-align: top;
}

.v-btn:focus {
  outline: none;
}

.v-card--link:focus::before {
  opacity: 0;
}

.coin_icon_point::after {
  margin-left: 2px;
  margin-top: 0px;
  content: "";
  background-image: var(--coin_img);
  background-size: 20px 20px;
  display: inline-block;
  width: 20px;
  height: 20px;
  vertical-align: top;
}

.coin_icon_small::after {
  margin-left: 2px;
  margin-top: 3px;
  content: "";
  background-image: var(--coin_img);
  background-size: 20px 20px;
  display: inline-block;
  width: 20px;
  height: 20px;
  vertical-align: top;
}

.coin_icon_medium::after {
  margin-left: 6px;
  margin-top: 13px;
  content: "";
  background-image: var(--coin_img);
  background-size: 40px 40px;
  display: inline-block;
  width: 40px;
  height: 40px;
  vertical-align: top;
}

.coin_icon_big::after {
  margin-left: 10px;
  margin-top: 15px;
  content: "";
  background-image: var(--coin_img);
  background-size: 50px 50px;
  display: inline-block;
  width: 50px;
  height: 50px;
  vertical-align: top;
}

.coin_icon_large::after {
  margin-left: 10px;
  margin-top: 15px;
  content: "";
  background-image: var(--coin_img);
  background-size: 130px 130px;
  display: inline-block;
  width: 130px;
  height: 130px;
  vertical-align: top;
}

.chip_point {
  width: 60px;
}

.Raleway {
  font-family: Raleway;
}

.RalewayBold {
  font-family: "Raleway";
  font-weight: 500 !important;
}

.bold {
  font-weight: bold;
}

.font8 {
  font-size: 8px;
}

.font10 {
  font-size: 10px;
}

.font12 {
  font-size: 12px;
}

.font14 {
  font-size: 14px;
}

.font16 {
  font-size: 16px !important;
}

.font18 {
  font-size: 18px;
}

.font20 {
  font-size: 20px;
}

.font24 {
  font-size: 24px;
}

.font26 {
  font-size: 26px;
}

.font35 {
  font-size: 35px;
}

.font28 {
  font-size: 28px;
}

.font45 {
  font-size: 45px;
}

.font55 {
  font-size: 55px;
}

.weight1000 {
  font-weight: 1000;
}

.link {
  cursor: pointer;
}

.slide-leave-active,
.slide-enter-active {
  transition: 0.3s;
}

.slide-enter {
  transform: translate(100%, 0);
}

.slide-leave-to {
  transform: translate(-100%, 0);
}

.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
}

/* Text caption font is handled by body.target-shop-font at line 1894-1899 */

.v-tabs-bar__content {
  padding-left: 0px;
}

.tab-wrapper {
  height: 100%;
  /* Set to desired height of entire tabbed section, or use flex, or ... */
}

.fade-slide-enter-active {
  transition: all 1.5s ease;
}

.fade-slide-leave-active {
  transition: all 1.5s ease;
}

.fade-slide-enter,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

/* @media only screen and (max-width: 1025px) {
  body{
    display: flex !important;
    justify-content: center;
    align-items: stretch;
  }

} */
</style>



// WEBPACK FOOTER //
// src/App.vue